<template>
  <div>
    <UserGuidVue :picsdata="pics">
      </UserGuidVue>
  </div>
</template>

<script>
import UserGuidVue from '../components/UserGuid.vue'

export default {
  name: 'Meizu',
  data () {
    return {
      pics: [
        { url: require('../assets/meizu1.png'), text: '点击设置' },
        { url: require('../assets/meizu2.png'), text: '点击关于本机' },
        { url: require('../assets/meizu3.png'), text: '连续点击系统版本7次，开启开发者选项' },
        { url: require('../assets/meizu4.png'), text: '返回设置，找到辅助功能，点击开发者选项' },
        { url: require('../assets/meizu5.png'), text: '打开USB调试，' }
      ]
    }
  },
  components: {
    UserGuidVue
  }
}
</script>

<style>

</style>
